import { FC } from 'react'
import { AlertsOverview } from './components/AlertsOverview'
import { IncidentsOverview } from './components/IncidentsOverview'
import { AlertsOverTime } from './components/AlertsOverTime'
import { OpenCases } from './components/OpenCases'
import { Container, TopGrid, BottomGrid } from './overview.styles'
import { useMdrCasesQuery } from '@core/hooks/useMdrCasesQuery'
import MdrSkeleton from '@routes/mdr/components/skeleton/MdrSkeleton'

export const timeRangeOptions = [
    { id: 'all', label: 'All Times', checked: true },
    { id: '60d', label: 'Last 60 days', checked: false },
    { id: '30d', label: 'Last 30 days', checked: false },
    { id: '7d', label: 'Last 7 days', checked: false },
]

export const Overview: FC = () => {
    const { isLoading } = useMdrCasesQuery()

    if (isLoading) {
        return <MdrSkeleton />
    }

    return (
        <Container>
            <TopGrid>
                <AlertsOverview />
                <IncidentsOverview />
            </TopGrid>

            <BottomGrid>
                <OpenCases />
                <AlertsOverTime />
            </BottomGrid>
        </Container>
    )
}
